import { DepositMethodType, DepositCategoryType } from '@golden/gdk-admin'
import TKeyType from '../../i18ns/admin/TKeyType'

const depositTypeName: { [key in DepositMethodType]: TKeyType } = {
  [DepositMethodType.ONLINE]: 'deposit.online',
  [DepositMethodType.ONLINE_MANUAL]: 'deposit.onlineManual',
  [DepositMethodType.SCAN_WECHAT]: 'deposit.scanWechat',
  [DepositMethodType.SCAN_ALIPAY]: 'deposit.scanAlipay',
  [DepositMethodType.GOUBAO]: 'deposit.goubao',
  [DepositMethodType.TOPAY]: 'deposit.topay',
  [DepositMethodType.EBPAY]: 'deposit.ebpay',
  [DepositMethodType.CRYPTO_TRC]: 'deposit.cryptoTrc',
  [DepositMethodType.CRYPTO_ERC]: 'deposit.cryptoErc',
  [DepositMethodType.MANUAL]: 'deposit.manual',
  [DepositMethodType.MANUAL_DEPOSIT]: 'deposit.manualDeposit',
  [DepositMethodType.MANUAL_EVENT]: 'deposit.manualActivity',
  [DepositMethodType.MANUAL_OTHER]: 'deposit.manualOthers',
  [DepositMethodType.MANUAL_RISK_ADJUSTMENT]: 'deposit.manualRisk',
  [DepositMethodType.UNION_PAY_QUICK]: 'deposit.unionPayQuick',
  [DepositMethodType.UNION_PAY_CLOUD]: 'deposit.unionPayCloud',
  [DepositMethodType.CGPAY]: 'deposit.cgpay',
  [DepositMethodType.CGPAY_USDT]: 'deposit.cgpay_usdt',
  [DepositMethodType.KOIPAY]: 'deposit.koipay',
  [DepositMethodType.E_CNY]: 'deposit.e_cny',
  [DepositMethodType.PAY988]: 'deposit.pay988',
  [DepositMethodType.PAY808]: 'deposit.pay808',
  [DepositMethodType.KDPAY]: 'deposit.kdpay'
}

export const depositCategoryTypeName: { [key in DepositCategoryType]: TKeyType } = {
  [DepositCategoryType.ONLINE]: 'deposit.online',
  [DepositCategoryType.ONLINE_MANUAL]: 'deposit.onlineManual',
  [DepositCategoryType.SCAN_WECHAT]: 'deposit.scanWechat',
  [DepositCategoryType.SCAN_ALIPAY]: 'deposit.scanAlipay',
  [DepositCategoryType.GOUBAO]: 'deposit.goubao',
  [DepositCategoryType.TOPAY]: 'deposit.topay',
  [DepositCategoryType.EBPAY]: 'deposit.ebpay',
  [DepositCategoryType.CRYPTO]: 'deposit.crypto',
  [DepositCategoryType.MANUAL]: 'deposit.manual',
  [DepositCategoryType.UNION_PAY_QUICK]: 'deposit.unionPayQuick',
  [DepositCategoryType.UNION_PAY_CLOUD]: 'deposit.unionPayCloud',
  [DepositCategoryType.CGPAY]: 'deposit.cgpay',
  [DepositCategoryType.CGPAY_USDT]: 'deposit.cgpay_usdt',
  [DepositCategoryType.KOIPAY]: 'deposit.koipay',
  [DepositCategoryType.E_CNY]: 'deposit.e_cny',
  [DepositCategoryType.PAY988]: 'deposit.pay988',
  [DepositCategoryType.PAY808]: 'deposit.pay808',
  [DepositCategoryType.KDPAY]: 'deposit.kdpay'
}

export const manualDepositTypeName = {
  [DepositMethodType.MANUAL]: 'deposit.manual',
  [DepositMethodType.MANUAL_DEPOSIT]: 'deposit.manualDeposit',
  [DepositMethodType.MANUAL_EVENT]: 'deposit.manualActivity',
  [DepositMethodType.MANUAL_OTHER]: 'deposit.manualOthers',
  [DepositMethodType.MANUAL_RISK_ADJUSTMENT]: 'deposit.manualRisk'
}

export default depositTypeName
